/* DANYCARE — Promo-Aktionen (29.07.2026).
 * Daten: JSON aus snippets/dc-promo.liquid (Metaobject promo_aktion, nur aktive Einträge).
 * Targeting (Entscheidung Andreas): Pop-up über url_muster (leer = alle Seiten);
 * PDP-Box NUR auf Produkten aus box_produkte (Preisvorteil-Behauptung nur dort,
 * wo der Rabatt wirklich gilt — Abgleich: scripts/promo-aktion-audit.mjs).
 * Textfelder kommen als fertiges HTML (metafield_tag: multi_line ODER rich_text).
 * localStorage/sessionStorage nur funktional (Frequenz-Cap, A/B-Zuteilung) — kein Consent-Thema.
 * Zeitfenster wird HIER geprüft (Liquid ist CDN-gecacht); Zeiten als UTC-Epoch aus Liquid. */
(function () {
  'use strict';
  var dataEl = document.getElementById('dc-promo-data');
  if (!dataEl) return;
  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var kunde = data.kunde || {};
  var pfad = window.location.pathname;
  var jetzt = Math.floor(Date.now() / 1000);
  var produktMatch = pfad.match(/\/products\/([^/?]+)/);
  var produktHandle = produktMatch ? decodeURIComponent(produktMatch[1]) : null;

  // Globale Gates: Zeitfenster + Zielgruppe (gelten für Pop-up UND Box)
  function aktiv(a) {
    if (a.start && jetzt < a.start) return false;
    if (a.ende && jetzt >= a.ende) return false;
    var z = a.zielgruppe || 'alle';
    if (z === 'nur-gaeste' && kunde.eingeloggt) return false;
    if (z === 'nur-eingeloggt' && !kunde.eingeloggt) return false;
    if (z === 'nur-b2b' && !kunde.b2b) return false;
    return true;
  }

  // Pop-up-Gate: url_muster (Einzelfeld, kommagetrennt; robust auch für Listen-Feld)
  function musterPasst(a) {
    var muster = a.url_muster;
    if (typeof muster === 'string') muster = muster.split(/[,\n]/);
    muster = (muster || []).map(function (m) { return String(m).trim(); }).filter(Boolean);
    return !muster.length || muster.some(function (m) { return pfad.indexOf(m) !== -1; });
  }

  // Box-Gate: aktuelles Produkt ist in box_produkte referenziert
  function boxPasst(a) {
    return !!produktHandle && (a.box_handles || []).indexOf(produktHandle) !== -1;
  }

  function zeigtPopup(a) { return (a.darstellung || 'popup') === 'popup' || a.darstellung === 'beides'; }
  function zeigtBox(a) { return a.darstellung === 'pdp-box' || a.darstellung === 'beides'; }

  var alle = (data.aktionen || []).filter(aktiv);
  // Erste passende Aktion je Kanal gewinnt — Überschneidungen laut Playbook vermeiden.
  var popupAktion = alle.filter(function (a) { return zeigtPopup(a) && musterPasst(a); })[0];
  var boxAktion = alle.filter(function (a) { return zeigtBox(a) && boxPasst(a); })[0];
  if (!popupAktion && !boxAktion) return;

  function lsGet(key) { try { return localStorage.getItem(key); } catch (e) { return null; } }
  function lsSet(key, val) { try { localStorage.setItem(key, val); } catch (e) {} }

  // A/B-Zuteilung: stabil pro Besucher, nur wenn Variante B gepflegt ist
  function inhaltFuer(a) {
    var variante = 'a';
    if (a.variante_b_titel) {
      var vKey = 'dc-promo-var-' + a.handle;
      variante = lsGet(vKey);
      if (variante !== 'a' && variante !== 'b') {
        var split = parseInt(a.split_b_prozent, 10);
        if (isNaN(split) || split < 0 || split > 100) split = 50;
        variante = Math.random() * 100 < split ? 'b' : 'a';
        lsSet(vKey, variante);
      }
    }
    return variante === 'b'
      ? {
          titel: a.variante_b_titel || a.titel,
          textHtml: a.variante_b_text_html || a.text_html,
          ctaLabel: a.variante_b_cta_label || a.cta_label,
          ctaZiel: a.variante_b_cta_ziel || a.cta_ziel,
        }
      : { titel: a.titel, textHtml: a.text_html, ctaLabel: a.cta_label, ctaZiel: a.cta_ziel };
  }

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }

  /* ---------------------------------------------------------------- PDP-Box
   * Inline-Hinweis unter dem Preisblock — ohne Frequenz-Cap (Info, kein Nerv-Faktor). */
  if (boxAktion && !document.querySelector('.dc-promo-box')) {
    var anker = document.querySelector('.dc-pdp-price');
    if (anker) {
      var bInhalt = inhaltFuer(boxAktion);
      var box = document.createElement('aside');
      box.className = 'dc-promo-box';
      box.innerHTML =
        '<p class="dc-promo-box__titel">' + esc(bInhalt.titel) + '</p>' +
        (bInhalt.textHtml ? '<div class="dc-promo-box__text">' + bInhalt.textHtml + '</div>' : '') +
        (bInhalt.ctaLabel && bInhalt.ctaZiel
          ? '<a class="dc-promo-box__cta" href="' + esc(bInhalt.ctaZiel) + '">' + esc(bInhalt.ctaLabel) + '</a>'
          : '');
      anker.insertAdjacentElement('afterend', box);
    }
  }

  /* ------------------------------------------------------------------ Pop-up */
  if (!popupAktion) return;

  var frequenz = popupAktion.frequenz || 'einmal';
  var seenKey = 'dc-promo-seen-' + popupAktion.handle;
  if (frequenz === 'einmal' && lsGet(seenKey)) return;
  if (frequenz === 'pro-session') {
    try { if (sessionStorage.getItem(seenKey)) return; } catch (e) {}
  }

  var gezeigt = false;
  function zeigen() {
    if (gezeigt) return;
    gezeigt = true;
    if (frequenz === 'einmal') lsSet(seenKey, '1');
    if (frequenz === 'pro-session') { try { sessionStorage.setItem(seenKey, '1'); } catch (e) {} }

    var pInhalt = inhaltFuer(popupAktion);
    var overlay = document.createElement('div');
    overlay.className = 'dc-promo-overlay';
    overlay.innerHTML =
      '<div class="dc-promo-card" role="dialog" aria-modal="true" aria-labelledby="dc-promo-titel">' +
      '<button type="button" class="dc-promo-close" aria-label="Schließen">&times;</button>' +
      '<h2 id="dc-promo-titel" class="dc-promo-card__titel">' + esc(pInhalt.titel) + '</h2>' +
      (pInhalt.textHtml ? '<div class="dc-promo-card__text">' + pInhalt.textHtml + '</div>' : '') +
      (pInhalt.ctaLabel && pInhalt.ctaZiel
        ? '<a class="dc-promo-card__cta" href="' + esc(pInhalt.ctaZiel) + '">' + esc(pInhalt.ctaLabel) + '</a>'
        : '') +
      '</div>';
    document.body.appendChild(overlay);

    var vorherFokus = document.activeElement;
    function schliessen() {
      overlay.remove();
      document.removeEventListener('keydown', aufEsc);
      if (vorherFokus && vorherFokus.focus) vorherFokus.focus();
    }
    function aufEsc(e) { if (e.key === 'Escape') schliessen(); }
    overlay.addEventListener('click', function (e) { if (e.target === overlay) schliessen(); });
    overlay.querySelector('.dc-promo-close').addEventListener('click', schliessen);
    document.addEventListener('keydown', aufEsc);
    var cta = overlay.querySelector('.dc-promo-card__cta');
    (cta || overlay.querySelector('.dc-promo-close')).focus();
  }

  var ausloeser = popupAktion.ausloeser || 'sofort';
  var sek = parseInt(popupAktion.verzoegerung_sekunden, 10);
  if (isNaN(sek) || sek < 0) sek = 5;

  if (ausloeser === 'verzoegert') {
    setTimeout(zeigen, sek * 1000);
  } else if (ausloeser === 'scroll') {
    var aufScroll = function () {
      var h = document.documentElement;
      var tiefe = (h.scrollTop + window.innerHeight) / h.scrollHeight;
      if (tiefe > 0.4) { window.removeEventListener('scroll', aufScroll); zeigen(); }
    };
    window.addEventListener('scroll', aufScroll, { passive: true });
  } else if (ausloeser === 'exit-intent') {
    if (window.matchMedia('(hover: hover)').matches) {
      var aufExit = function (e) {
        if (e.clientY <= 0) { document.removeEventListener('mouseout', aufExit); zeigen(); }
      };
      document.addEventListener('mouseout', aufExit);
    } else {
      setTimeout(zeigen, 20000); // Touch-Geräte: kein Exit-Intent möglich → 20-s-Fallback
    }
  } else {
    setTimeout(zeigen, 800); // „sofort“ mit Mini-Delay, damit die Seite erst steht
  }
})();
